import * as React from 'react';
import { DetailedIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const EmptyStateProDetailedIcon = ({ size = 48 }: DetailedIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 151 119"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M51.828 76.784c-3.41 7.815-11.098 20.215-11.098 20.215.539 2.152 3.171 4.721 7.124 7.027 6.81 3.973 10.377 3.473 10.377 3.473s5.5-5.999 10-14.5c3.105-5.865 6.967-14.765 8.679-22.03a22.41 22.41 0 0 1 5.32 14.53c0 12.427-10.073 22.5-22.5 22.5-12.426 0-22.5-10.073-22.5-22.5 0-11.331 8.378-20.707 19.277-22.27-.736 2.382-3.122 9.986-4.68 13.555Z"
            fill="#222325"/>
        <path d="M38.153 33.64H34.23v5.257h3.922v-5.256Z"
            stroke="#222325"
            strokeWidth={1.703}
            strokeMiterlimit={10}
            strokeLinejoin="round"/>
        <path d="m113.35 24.033-37.213 3.324M79.816 45.457l33.533 3.06M114.196 48.54c6.638 0 12.02-5.494 12.02-12.27 0-6.777-5.382-12.27-12.02-12.27-6.639 0-12.02 5.493-12.02 12.27 0 6.776 5.381 12.27 12.02 12.27ZM94.638 46.8c-3.043 0-5.494-5.181-5.494-10.758 0-5.578 2.462-10.343 5.494-10.343M62.739 28.208l-18.964.85a5.998 5.998 0 0 0-3.985 1.904 6.058 6.058 0 0 0-1.618 4.127v2.462a6.069 6.069 0 0 0 1.625 4.127 6.008 6.008 0 0 0 3.99 1.903l15.557.619a4.188 4.188 0 0 0 2.812-1.296 4.23 4.23 0 0 0 1.165-2.879c.187-4.009-.164-10.193-.89-11.795l-1.098-.695s3.878-2.86 5.69-.122c1.814 2.739 2.572 11.695 2.198 14.523"
            stroke="#222325"
            strokeWidth={1.703}
            strokeMiterlimit={10}/>
        <path d="M66.035 26.442c2-1.889 5.615-.221 6.538 1.999 1.153 2.926 1.89 14.191 1.89 14.191M53.325 43.95c-3.044 0-4.395-3.804-4.395-7.913 0-4.108 1.362-7.396 4.395-7.396"
            stroke="#222325"
            strokeWidth={1.703}
            strokeMiterlimit={10}/>
        <path d="M55.326 43.956c.274 2.187 3.955 3.523 4 6.925.043 3.401-3.15 15.937-7.498 25.903C48.418 84.6 40.23 97 40.23 97m31.027-70.56c2.967-1.037 5.746-.12 7.746 9.355s.802 20.704-1.04 29.704C75.928 75.442 72.73 84.5 68.23 93c-4.5 8.5-10.5 15-10.5 15"
            stroke="#222325"
            strokeWidth={1.703}
            strokeMiterlimit={10}/>
        <path d="M105.93 36.14s8-10.14 16.5.117c-1.257 1.447-7.186 9.684-16.5-.117Z"
            stroke="#222325"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinejoin="round"/>
        <path d="M117.706 39.934c2.383 0 5.055-3.614 5.055-3.614s-2.672-3.955-5.055-3.955c-2.383 0-4.276 1.307-4.276 3.636 0 2.328 1.893 3.933 4.276 3.933Z"
            fill="#222325"/>
        <path d="M56.73 63.2c-11.008 1.466-19.5 10.892-19.5 22.301 0 12.426 10.074 22.5 22.5 22.5 12.427 0 22.5-10.074 22.5-22.5a22.413 22.413 0 0 0-5.5-14.74"
            stroke="#222325"
            strokeWidth={1.703}
            strokeMiterlimit={10}/>
    </svg>
);
EmptyStateProDetailedIcon.displayName = 'EmptyStateProDetailedIcon';
export default EmptyStateProDetailedIcon;
